import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import bioLinkService from './bioLinkServices';

// Get user from

const initialState = {
  createdBioLink: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  errorMsg: '',
};

// registerUser user
export const creatingBioLink = createAsyncThunk(
  'createdBioLink/creatingBioLink',

  async (createdBioLinkData, thunkAPI) => {
    try {
      return await bioLinkService.creatingBioLink(createdBioLinkData);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();

      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const bioLinkCreationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(creatingBioLink.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(creatingBioLink.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.createdBioLink = action.payload;
      })
      .addCase(creatingBioLink.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      });
  },
});

export default bioLinkCreationSlice.reducer;
